var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{attrs:{"size":_vm.size,"icon":_vm.resolve(_vm.icon),"beat-fade":_vm.beat_fade,"fade":_vm.fade},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }